module.exports = __webpack_public_path__ + "static/trivia-edba4094c7458ef78b07128840f5956f.png";